import { Body3, Body4, Bold, H6, TextDefinition, TextDefinitionParagraph, Indent } from '@ui';

export const PrivacyPolicy_61218 = ({ isOpCo }) => {
  return (
    <div>
      <H6>
        <Bold>Effective Date: 6/12/2018</Bold>
      </H6>

      <H6>
        <Bold>Tornado Privacy Notice</Bold>
      </H6>

      <Body4>
        Nvstr Financial LLC dba Tornado, Nvstr Technologies Inc., and our affiliates, (“Tornado” or “we”) are committed
        to protecting our customers’ personal information. This Privacy Notice (this “Notice”) explains how we collect
        and use customer information on this website (the “Site”), the types of customer information we receive and
        collect, and the steps that we take to safeguard your information. This Notice sets out items required by
        regulation. Please also refer to our Web Site Terms of Service and any other agreements with us for additional
        information and relevant provisions. All such agreements are incorporated herein by reference.
      </Body4>

      <H6>
        <Bold>How do we collect personal information?</Bold>
      </H6>

      <Body4>
        <Bold>Personal information.</Bold>
        When you apply for, open or maintain an account with us, or otherwise use our Site, we may collect certain
        personal information, depending on the product or service. The personal information we collect may include your
        name, address, telephone number, email address, Social Security Number, date of birth, income, net worth,
        employment information, investments and investment experience, risk tolerance, credit score, external bank
        account number, routing number, available balance, and current balance, as well as information about your
        personal investment ideas, goals or objectives.
      </Body4>
      <Body4>
        <Bold>Other information.</Bold>
        In addition to personal information, additional information, which does not identify you personally, may be
        collected by our web servers for the purpose of measuring statistics about our visitors, such as the number of
        visits to the Site, the average time spent on the Site and the pages viewed on the Site. Such
        non-personally-identifiable information may be used by Tornado and its affiliates or shared with third parties.
        In addition, we use analytical tools to help us monitor traffic patterns and to see how users navigate through
        the Site. These analytical tools are used by us and our affiliates and service providers only and we do not
        disseminate personal information to any other third party, except as described in this Notice.
      </Body4>

      <H6>
        <Bold>How do we use personal information?</Bold>
      </H6>

      <Body4>We may use personal information for a number of business purposes, including:</Body4>

      <ul>
        <li>
          <Body4>
            providing you with products and services that you have requested or informing you about products and
            services that we believe may be of interest to you;
          </Body4>
        </li>
        <li>
          <Body4>conducting credit checks;</Body4>
        </li>
        <li>
          <Body4>
            developing and improving products and services, enhancing the Site, identifying usage trends and learning
            about the markets in which we operate;
          </Body4>
        </li>
        <li>
          <Body4>
            verifying your identity and/or location (or the identity or location of your representative or agent) in
            order to allow access to your accounts, conduct online transactions and to maintain measures aimed at
            preventing fraud and protecting the security of account and personal information;
          </Body4>
        </li>
        <li>
          <Body4>complying with our regulatory, legal and ethical obligations, and contacting you.</Body4>
        </li>
        <li>
          <Body4></Body4>
        </li>
      </ul>
      <H6>
        <Bold>How do we collect and use your other information?</Bold>
      </H6>

      <Body4>
        We may send “cookies” to your web browser to store information on your computer. Cookies do not contain personal
        information, unless you knowingly provide such information. If you access your account online, cookies may be
        used to verify your identity, to authenticate you as a user on our system and to personalize aspects of your
        experience on the Site. Tornado may share information obtained from cookies with its employees, agents, and
        affiliates, but does not sell such information to unaffiliated third parties.
      </Body4>
      <Body4>
        We may use third-party “pixels”, which are similar to cookies and are used to track inbound traffic from
        advertisements on other websites (including, among other things, IP addresses). We do not provide personally
        identifiable information to advertisers, advertising platforms, or similar companies in connection with these
        pixels, although we may provide your IP address. Any information you have provided to, or which has been
        collected by, third-party advertisers, advertising platforms, or similar companies is subject to their
        respective policies and your agreements with such companies, to which Tornado is not a party.
      </Body4>
      <Body4>
        You are not required to use cookies and pixels. Most browsers and mobile devices offer their own settings to
        manage cookies and other privacy settings.
      </Body4>
      <Body4>
        We also collect information when you use our portfolio modeling tools, which we do not consider as your personal
        information. We do not generally share that information with others unless you permit it, but we may use that
        information in a variety of ways, including as set forth below.
      </Body4>

      <H6>
        <Bold>How do we share your information?</Bold>
      </H6>

      <Body4>
        We may disclose personal information we collect to our affiliates and service providers to the extent necessary
        in connection with providing services to you. Such service providers may include but are not limited to our{' '}
        {isOpCo ? `clearing broker, order management system provider,` : ''} web service provider and host. Service
        providers that receive your personal information must safeguard this information, and they may only use it for
        those purposes we specify. By applying for, opening, or maintaining an account with us, or otherwise using our
        Site, you consent to this type of sharing. If at any time you wish to withdraw this consent, you will be
        required to close your account.
      </Body4>
      <Body4>
        One of our service providers is Plaid, which provides software that facilitates financial account
        authentication, identification, and transaction processing. By applying for, opening, or maintaining an account
        with us, you acknowledge and agree that we will treat your personal information in accordance with Plaid’s
        privacy policy, available here:{' '}
        <a href="https://plaid.com/legal/#privacy-policy" target="_blank" rel="noreferrer">
          https://plaid.com/legal/#privacy-policy
        </a>
        . In addition, you expressly grant Plaid the right, power, and authority to access and transmit your personal
        data as reasonably necessary to provide its service to you.
      </Body4>
      <Body4>
        In addition, we may disclose information about you as required or permitted by law to law enforcement or other
        regulatory or governmental officials. We may also use and disclose personal information as authorized by you,
        including without limitation information about positions and trades. We do not disclose personal information
        about our customers to non-affiliated third parties, except as described in this Notice.
      </Body4>
      <Body4>
        You may be able to post information, comments or other written statements or materials. If you do so, the
        information you post or disclose will become public and may be available to other users. Any information you
        post will not be protected by this Notice. Your public profile will be visible to all users of the Site and may
        be indexed by search engines and available in search engine results.
      </Body4>

      <H6>
        <Bold>How may you limit the sharing of your information?</Bold>
      </H6>

      <Body4>
        <Bold>Non-affiliates:</Bold> You may limit or &ldquo;opt out&ldquo; of our sharing your personal information
        with non-affiliated third parties for joint or their own marketing purposes. We do not currently share your
        personal information with any non-affiliated third party in a manner that triggers this opt-out right.
        Accordingly, there is no need at this time for you to opt out or take any other action telling us not to share
        such information with non-affiliated third parties.
      </Body4>
      <Body4>
        <Bold>Affiliates:</Bold> You may also opt out of our sharing certain personal information (e.g., information
        about creditworthiness) among our affiliated companies. We don’t share information about your transactions and
        experiences (e.g., account balance, trading activity and account history) with companies that aren’t affiliates
        or service providers; therefore, there is no need at this time for you to exercise your opt-out right. You may
        elect to restrict our affiliated companies from marketing their products or services to you based on information
        about you that we share with them.
      </Body4>
      <Body4>
        If you wish to exercise your opt-out right for any reason described above, please contact us by email at
        legal@tornado.com.
      </Body4>

      <H6>
        <Bold>How do we protect your personal information?</Bold>
      </H6>

      <Body4>
        At Tornado, we make your safety and security a top priority and are committed to protecting your personal and
        financial information. To protect your personal information from unauthorized access and use, we use security
        measures and controls based on recognized security standards, regulations and industry best practices. The
        measures include reasonable physical, electronic and procedural safeguards to protect your personal information.
        Unfortunately, no data transmission or storage system can be guaranteed to be 100% secure. If you have reason to
        believe that your interaction with us is no longer secure (for example, if you feel that the security of your
        account with us has been compromised), please contact us immediately in accordance with the “Contact Us” section
        below.
      </Body4>

      <H6>
        <Bold>Links to Third-Party Sites</Bold>
      </H6>

      <Body4>
        Our websites may include links to third-party websites. Tornado is not responsible for the content or the
        privacy practices employed by other websites. We encourage you to review the terms and conditions of use and
        privacy policy of all websites you use, especially before providing personal information.
      </Body4>

      <H6>
        <Bold>Updates to this Notice</Bold>
      </H6>

      <Body4>
        We may update this Notice from time to time. The “Effective Date” legend at the top of this page indicates when
        this Notice was last revised. Any changes will become effective when we post the revised Notice on the Site.
        Your use of the Site following these changes means that you accept the revised Notice. We encourage you to refer
        to this Notice periodically to learn about updates to our privacy practices.
      </Body4>

      <H6>
        <Bold>Notice to California residents</Bold>
      </H6>

      <Body4>
        In accordance with California law, we will not share information we collect about you with non-affiliates,
        except as allowed by law. For example, we may share information with your consent or to service your accounts.
      </Body4>

      <H6>
        <Bold>Contact Us</Bold>
      </H6>

      <Body4>
        If you want to access or update the personal information you submitted to Tornado or if you have any questions
        regarding this Notice, please contact us by email at legal@tornado.com.
      </Body4>
    </div>
  );
};

export const PrivacyPolicy = () => {
  return (
    <div>
      <section>
        <Body4>
          <Bold>Effective Date: 11/24/2021</Bold>
        </Body4>

        <Body4>
          This Privacy Policy describes how Nvstr Financial LLC dba Tornado and Nvstr Technologies Inc. and our
          affiliates (<Bold>&quot;Tornado,&quot; &quot;we&quot;, &quot;us&quot; or &quot;our&quot;</Bold>) handle
          personal information that we collect through our digital properties that link to this Privacy Policy,
          including our website and mobile applications (collectively, the
          <Bold>&quot;Service&quot;</Bold>
          ), as well as through social media, our marketing activities and other activities described in this Privacy
          Policy.
        </Body4>

        <Body4>
          Tornado may provide additional or supplemental privacy policies to individuals for specific products or
          services that we offer at the time we collect personal information.
        </Body4>
      </section>

      <section>
        <H6>
          <Bold>Index</Bold>
        </H6>

        <Indent>
          <Body4>
            <Bold>
              <a href="#personal-information">Personal information we collect</a>
            </Bold>
          </Body4>
          <Body4>
            <Bold>
              <a href="#how-we-use">How we use your personal information</a>
            </Bold>
          </Body4>
          <Body4>
            <Bold>
              <a href="#how-we-share">How we share your personal information</a>
            </Bold>
          </Body4>
          <Body4>
            <Bold>
              <a href="#your-choices">Your choices</a>
            </Bold>
          </Body4>
          <Body4>
            <Bold>
              <a href="#other-sites">Other sites and services</a>
            </Bold>
          </Body4>
          <Body4>
            <Bold>
              <a href="#security">Security</a>
            </Bold>
          </Body4>
          <Body4>
            <Bold>
              <a href="#international">International data transfer</a>
            </Bold>
          </Body4>
          <Body4>
            <Bold>
              <a href="#children">Children</a>
            </Bold>
          </Body4>
          <Body4>
            <Bold>
              <a href="#changes">Changes to this Privacy Policy</a>
            </Bold>
          </Body4>
          <Body4>
            <Bold>
              <a href="#contact">How to contact us</a>
            </Bold>
          </Body4>
        </Indent>
      </section>

      <section>
        <H6>
          <Bold>
            <span id="personal-information">Personal information we collect</span>
          </Bold>
        </H6>

        <Body4>
          <Bold></Bold> Personal information you may provide to us through the Service or otherwise includes:
        </Body4>

        <TextDefinitionParagraph
          phrase="Information you provide to us."
          definition="We may combine personal information we receive from you with personal information we obtain from other sources, such as:"
          bullets={[
            <TextDefinition
              key="Contact data,"
              phrase="Contact data,"
              definition="such as your first and last name, address, telephone number and email address. "
            />,
            <TextDefinition
              key="Demographic data,"
              phrase="Demographic data,"
              definition="such as your city, state, date of birth, country of residence, and postal code."
            />,
            <TextDefinition
              key="Profile data,"
              phrase="Profile data,"
              definition="such as the username and password that you may set
        to establish an online account on the Service and information about your
        investment risk tolerance. "
            />,
            <TextDefinition
              key="Employment data, "
              phrase="Employment data, "
              definition="including your employer and title. "
            />,
            <TextDefinition
              key="Financial data, "
              phrase="Financial data, "
              definition="such as your income, net
        worth, investments and investment experience, financial account numbers,
        routing numbers and available and current account balances. For control
        persons of public companies, we may collect additional pieces of
        information including number of shares owned, percentage ownership of
        company, and percent voting control of the company."
            />,
            <TextDefinition
              key="Communications data"
              phrase="Communications data"
              definition="that we exchange with you, including when you
        contact us through the Service, social media, customer support, or
        otherwise. "
            />,
            <TextDefinition
              key="Transactional data, "
              phrase="Transactional data, "
              definition="such as information needed to
        complete your orders on or through the Service or to manage your
        subscription, including order numbers and transaction history. "
            />,
            <TextDefinition
              key="Marketing data, "
              phrase="Marketing data, "
              definition="such as your preferences for receiving our marketing
        communications and details about your engagement with them."
            />,
            <TextDefinition
              key="User-generated content, "
              phrase="User-generated content, "
              definition="such as profile pictures, comments, questions,
        messages, works of authorship, and other content or information that you
        generate, transmit, or otherwise make available on the Service, as well
        as associated metadata. "
            />,
            <TextDefinition
              key="Government-issued identification numbers,"
              phrase="Government-issued identification numbers,"
              definition="such as national identification number (e.g. Social Security Number, tax
        identification number, passport number), state or local identification
        number (e.g., driver’s license or state ID number), and an image of the
        relevant identification card, for the purpose of confirming your
        identity to comply with relevant laws. "
            />,
            <TextDefinition
              key="Other proof of address,"
              phrase="Other proof of address,"
              definition="such as residential lease statements, mortgage statements, or utility
        bills, for the purpose of confirming your place of residence to comply
        with relevant laws. "
            />,
            <TextDefinition
              key="Payment data"
              phrase="Payment data"
              definition="needed to complete transactions,
        including payment card information or bank account number. "
            />,
            <TextDefinition
              key="Other data"
              phrase="Other data"
              definition="not specifically listed here, which we will use as described in
        this Privacy Policy or as otherwise disclosed at the time of collection."
            />,
          ]}
          noMargin
        />

        <TextDefinitionParagraph
          phrase="Third-party sources."
          definition="We may combine personal information we receive from you with personal information we obtain from other sources, such as:"
          bullets={[
            <TextDefinition
              key="Public sources"
              phrase="Public sources,"
              definition="such as government agencies, public records, social media platforms, and other public sources."
            />,
            <TextDefinition
              key="Data providers"
              phrase="Data providers,"
              definition="such as information services and data licensors that provide demographic and other information."
            />,
            <TextDefinition
              key="Identification verification and fraud prevention services"
              phrase="Identification verification and fraud prevention services,"
              definition="such as those provided by Socure, Apex Clearing, and Equifax."
            />,
            <TextDefinition
              key="Third-party services"
              phrase="Third-party services,"
              definition="such as social media services that you use to log into or otherwise link to your Service account."
            />,
          ]}
          noMargin
        />

        <TextDefinitionParagraph
          phrase="Automatic data collection"
          definition="We, our service providers, and our business partners may automatically log information about you, your computer or mobile device, and your interaction over time with the Service, our communications and other online services, such as:"
          bullets={[
            <TextDefinition
              key="Device data"
              phrase="Device data,"
              definition="such as your computer’s or mobile device’s operating system type and version, manufacturer and model, browser type, screen resolution, RAM and disk size, CPU usage, device type (e.g., phone, tablet), IP address, unique identifiers (including identifiers used for advertising purposes), language settings, mobile device carrier, radio/network information (e.g., Wi-Fi, LTE, 3G), and general location information such as city, state or geographic area."
            />,
            <TextDefinition
              key="Online activity data"
              phrase="Online activity data,"
              definition="such as pages or screens you viewed, how long you spent on a page or screen, the website you visited before browsing to the Service, navigation paths between pages or screens, information about your activity on a page or screen, access times and duration of access, and whether you have opened our emails or clicked links within them."
            />,
          ]}
          noMargin
        />

        <TextDefinitionParagraph
          phrase="Cookies and similar technologies."
          definition="Some of the automatic collection described above is facilitated by the following technologies:"
          bullets={[
            <TextDefinition
              key="Cookies"
              phrase="Cookies,"
              definition={`which are small text files that websites store on user devices and that allow web servers to record users’ web browsing activities and remember their submissions, preferences, and login status as they navigate a site. Cookies used on our sites include both "session cookies" that are deleted when a session ends, "persistent cookies" that remain longer, first party" cookies that we place and "third party" cookies that our third-party business partners and service providers place.`}
            />,
            <TextDefinition
              key="Local storage technologies"
              phrase="Local storage technologies,"
              definition="like HTML5 and Flash, that provide cookie-equivalent functionality but can store larger amounts of data on your device outside of your browser in connection with specific applications."
            />,
            <TextDefinition
              key="Web beacons"
              phrase="Web beacons,"
              definition="also known as pixel tags or clear GIFs, which are used to demonstrate that a webpage or email address was accessed or opened, or that certain content was viewed or clicked."
            />,
            <TextDefinition
              key="Session replay technologies"
              phrase="Session replay technologies."
              definition={
                <>
                  We use third-party services provided by Hotjar that employ software code to record users’ interactions
                  with the Services in a manner that allows us to watch DVR-like replays of those user sessions. The
                  replays include users’ clicks, mouse movements, and scrolls during those sessions. These replays help
                  us diagnose usability problems and identify areas for improvement. You can learn more about Hotjar at{' '}
                  <a href="https://www.hotjar.com/legal/policies/privacy/">
                    https://www.hotjar.com/legal/policies/privacy/
                  </a>{' '}
                  and learn how to opt-out of data collection by Hotjar here:{' '}
                  <a href="https://www.hotjar.com/policies/do-not-track/">
                    https://www.hotjar.com/policies/do-not-track/
                  </a>
                  .
                </>
              }
            />,
          ]}
          noMargin
        />

        <TextDefinitionParagraph
          phrase=""
          definition="These technologies are used for the following purposes:"
          bullets={[
            <TextDefinition
              key="Technical operation"
              phrase="Technical operation."
              definition="To allow the technical operation of the Service, such as by remembering your selections and preferences as you navigate the site, and whether you are logged in when you visit password protected areas of the Service."
            />,
            <TextDefinition
              key="Functionality"
              phrase="Functionality."
              definition="To help our third-party advertising partners collect information about how you use the Service and other online services over time, which they use to show you ads on other online services they believe will interest you and measure how the ads perform."
            />,
            <TextDefinition
              key="Analytics"
              phrase="Analytics."
              definition={
                <>
                  To help us understand user activity on the Service, including which pages are most and least visited
                  and how visitors move around the Service, as well as user interactions with our emails. For example,
                  we use Google Analytics for this purpose. You can learn more about Google Analytics and how to prevent
                  the use of Google Analytics relating to your use of our sites{' '}
                  <a href="https://tools.google.com/dlpage/gaoptout?hl=en" target="_blank" rel="noreferrer">
                    here
                  </a>
                  . We also use Amplitude; you can learn more about Amplitude’s privacy practices{' '}
                  <a href="https://amplitude.com/privacy" target="_blank" rel="noreferrer">
                    here
                  </a>
                  .
                </>
              }
            />,
          ]}
          noMargin
        />
        <TextDefinition
          phrase="Data about others."
          definition="We offer features that help users invite others to use the Service and may collect contact details about these invitees so we can deliver their invitations. Please do not refer someone to us or share their contact details with us unless you have their permission to do so."
        />
      </section>
      <section>
        <Body3>
          <Bold>
            <span id="how-we-use">How we use your personal information</span>
          </Bold>
        </Body3>

        <Body4>
          We may use your personal information for the following purposes or as otherwise described at the time of
          collection:
        </Body4>

        <TextDefinitionParagraph
          phrase="Service delivery."
          definition="We may use your personal information to:"
          bullets={[
            <TextDefinition key={'1'} definition="provide, operate and improve the Service and our business;" />,
            <TextDefinition key={'2'} definition="verify your identity;" />,
            <TextDefinition key={'3'} definition="establish and maintain your user profile on the Service;" />,
            <TextDefinition
              key={'4'}
              definition="facilitate your invitations to contacts who you want to invite to join the Service;"
            />,
            <TextDefinition
              key={'5'}
              definition="enable security features of the Service, such as by sending you security codes via email or SMS, and remembering devices from which you have previously logged in;"
            />,
            <TextDefinition
              key={'6'}
              definition="communicate with you about the Service, including by sending announcements, updates, security alerts, and support and administrative messages, including communications we are required by law to make;"
            />,
            <TextDefinition
              key={'7'}
              definition="understand your needs and interests, and personalize your experience with the Service and our communications; and"
            />,
            <TextDefinition
              key={'8'}
              definition="provide support for the Service, and respond to your requests, questions and feedback."
            />,
          ]}
          noMargin
        />

        <TextDefinitionParagraph
          phrase="Research and development."
          definition="We may use your personal information for research and development purposes, including to analyze and improve the Service and our business. As part of these activities, we may create aggregated, de-identified or other anonymous data from personal information we collect. We make personal information into anonymous data by removing information that makes the data personally identifiable to you. We may use this anonymous data and share it with third parties for our lawful business purposes, including to analyze and improve the Service and promote our business."
        />

        <TextDefinitionParagraph
          phrase="Marketing and advertising."
          definition="We, our service providers and our third-party advertising partners may collect and use your personal information for marketing and advertising purposes:"
          bullets={[
            <TextDefinition
              key="Direct marketing"
              phrase="Direct marketing."
              definition={
                <>
                  We may send you direct marketing communications as permitted by law. You may opt-out of our marketing
                  communications as described in the <a href="#opt-out">Opt-out of marketing</a> section below.
                </>
              }
            />,
            <TextDefinition
              key="Interest-based advertising"
              phrase={
                <>
                  <span id="interest-based-advertising">Interest-based advertising.</span>
                </>
              }
              definition="Our third-party advertising partners may use cookies and similar technologies to collect information about your interaction (including the data described in the automatic data collection section above) with the Service, our communications and other online services over time, and use that information to serve online ads that they think will interest you. This is called interest-based advertising. We may also share information about our users with these companies to facilitate interest-based advertising to those or similar users on other online platforms."
            />,
          ]}
          noMargin
        />

        <TextDefinitionParagraph
          phrase={
            <>
              <span id="compliance-and-protection">Compliance and protection.</span>
            </>
          }
          definition="We may use your personal information to:"
          bullets={[
            <TextDefinition
              key="1"
              definition="comply with applicable laws, lawful requests, and legal process, such as to respond to subpoenas or requests from government authorities;"
            />,
            <TextDefinition
              key="2"
              definition="protect our, your or others’ rights, privacy, safety or property (including by making and defending legal claims);"
            />,
            <TextDefinition
              key="3"
              definition="audit our internal processes for compliance with legal and contractual requirements or our internal policies;"
            />,
            <TextDefinition key="4" definition="enforce the terms and conditions that govern the Service; and" />,
            <TextDefinition
              key="5"
              definition="prevent, identify, investigate and deter fraudulent, harmful, unauthorized, unethical or illegal activity, including cyberattacks and identity theft."
            />,
          ]}
          noMargin
        />

        <TextDefinition
          phrase="With your consent."
          definition="In some cases, we may specifically ask for your consent to collect, use or share your personal information, such as when required by law."
        />

        <TextDefinition
          phrase="Retention."
          definition="We generally retain personal information to fulfill the purposes for which we collected it, including for the purposes of satisfying any legal, accounting, or reporting requirements, to establish or defend legal claims, or for fraud prevention purposes. To determine the appropriate retention period for personal information, we may consider factors such as the amount, nature, and sensitivity of the personal information, the potential risk of harm from unauthorized use or disclosure of your personal information, the purposes for which we process your personal information and whether we can achieve those purposes through other means, and the applicable legal requirements."
        />
      </section>
      <section>
        <Body3>
          <span id="how-we-share"></span>
          <Bold>How we share your personal information</Bold>
        </Body3>

        <Body4>
          We may share your personal information with the following parties and as otherwise described in this Privacy
          Policy or at the time of collection.
        </Body4>

        <TextDefinition
          phrase="Affiliates."
          definition="Our corporate parent, subsidiaries, and affiliates, for purposes consistent with this Privacy Policy."
        />

        <TextDefinition
          phrase="Service providers."
          definition={
            <>
              Third parties that provide services on our behalf or help us operate the Service or our business (such as
              clearing brokers, order management system providers, hosting, information technology, customer support,
              email delivery, marketing, consumer research and website analytics). For example, we use Plaid for
              financial account authentication, identification and transaction processing (view Plaid’s privacy policy{' '}
              <a href="https://plaid.com/legal/#privacy-policy" target="_blank" rel="noreferrer">
                here
              </a>
              ), Apex Clearing for clearing and custody services (view Apex Clearing’s privacy policy{' '}
              <a href="https://www.apexclearing.com/privacy-policy/" target="_blank" rel="noreferrer">
                here
              </a>
              ) and Socure for identity verification and fraud prevention services (view Socure’s privacy policy{' '}
              <a href="https://www.socure.com/privacy" target="_blank" rel="noreferrer">
                here
              </a>
              ). If you enter personal information into the Digital Analyst feature, such information will be shared
              with OpenAI, a generative artificial intelligence service (view OpenAI's privacy policy{' '}
              <a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noreferrer">
                here
              </a>
              ).
            </>
          }
        />

        <TextDefinition
          phrase="Payment processors."
          definition={
            <>
              Any payment card information you use to make a purchase on the Service is collected and processed directly
              by our payment processor, Authorize.net, a Visa Solution, which may use your payment data in accordance
              with its privacy policy, available{' '}
              <a href="https://usa.visa.com/legal/privacy-policy.html" target="_blank" rel="noreferrer">
                here
              </a>
              .
            </>
          }
        />

        <TextDefinition
          phrase="Advertising partners."
          definition={
            <>
              Third-party advertising companies for the{' '}
              <a href="#interest-based-advertising">interest-based advertising purposes</a> described above.
            </>
          }
        />

        <TextDefinition
          phrase="Linked third-party services."
          definition="If you log into the Service with, or otherwise link your Service account to, a social media or other third-party service, such as Facebook or Google, we may share your personal information with that third-party service. The third party’s use of the shared information will be governed by its privacy policy and the settings associated with your account with the third-party service."
        />

        <TextDefinition
          phrase="Professional advisors."
          definition="Professional advisors, such as lawyers, auditors, bankers and insurers, where necessary in the course of the professional services that they render to us."
        />

        <TextDefinition
          phrase="Authorities and others."
          definition={
            <>
              Law enforcement, government authorities, and private parties, as we believe in good faith to be necessary
              or appropriate for the <a href="#compliance-and-protection">compliance and protection purposes</a>{' '}
              described above.
            </>
          }
        />

        <TextDefinition
          phrase="Business transferees."
          definition="Acquirers and other relevant participants in business transactions (or negotiations of or due diligence for such transactions) involving a corporate divestiture, merger, consolidation, acquisition, reorganization, sale or other disposition of all or any portion of the business or assets of, or equity interests in, Tornado or our affiliates (including, in connection with a bankruptcy or similar proceedings)."
        />

        <TextDefinition
          phrase="Other users and the public."
          definition="You may be able to post information, comments or other written statements or materials to the Service, which may become visible to other users and the public. We may also share information, including but not limited to information about positions and trades, when you authorize us to do so. Additionally, your public profile will be visible to all users of the Service and may be indexed by search engines and available in search engine results."
        />

        <Body4>
          We make commercially reasonable efforts to verify that the parties with whom our mobile application shares
          personal information provide a level of protection of personal information consistent with the practices
          described in this Privacy Policy, except that all such parties described above other than service providers
          and affiliates may, to the extent permitted by law, use personal information as described in their own privacy
          policies.
        </Body4>
      </section>
      <section>
        <Body3>
          <span id="your-choices"></span>
          <Bold>Your choices</Bold>
        </Body3>

        <TextDefinition
          phrase={
            <>
              <span id="access-your-info">Access or update your information.</span>
            </>
          }
          definition="If you have registered for an account with us through the Service, you may review and update certain account information by logging into the account. This feature is available on the website by selecting your profile picture or initials in the top right of any page, selecting Settings, then navigating to Edit Profile, Account, or Preferences to make changes. It is available in the mobile app by pressing your profile picture or initials on the top right of any screen, then navigating to Edit Profile or Edit Account to make changes."
        />

        <TextDefinition
          phrase={
            <>
              <span id="opt-out"></span>
              Opt-out of marketing communications.
            </>
          }
          definition={
            <>
              You may opt-out of marketing-related emails by following the opt-out or unsubscribe instructions at the
              bottom of the email, by following the instructions in the &quot;
              <a href="#access-your-info">Access or update your information</a>
              &quot; section above and setting your email frequency to &quot;never&quot; or by{' '}
              <a href="#contact">contacting us</a>. Please note that if you choose to opt-out of marketing-related
              emails, you may continue to receive service-related and other non-marketing emails.
            </>
          }
        />

        <Body4>
          If you receive marketing text messages from us, you may opt out of receiving further marketing text messages
          from us by replying STOP to our marketing message.
        </Body4>

        <TextDefinitionParagraph
          phrase="Advertising choices."
          definition="You can limit use of your information for interest-based advertising by:"
          bullets={[
            <TextDefinition
              key="Browser settings"
              phrase="Browser settings."
              definition="Blocking third-party cookies in your browser settings."
            />,
            <TextDefinition
              key="Privacy browsers/plug-ins"
              phrase="Privacy browsers/plug-ins."
              definition="By using privacy browsers or ad-blocking browser plug-ins that let you block tracking technologies."
            />,
            <TextDefinitionParagraph
              key="Platform settings"
              phrase="Platform settings."
              definition="Google and Facebook offer opt-out features that let you opt-out of use of your information for interest-based advertising:"
              bullets={[
                <TextDefinition
                  key="Google"
                  definition={
                    <>
                      Google: <a href="https://adssettings.google.com/">https://adssettings.google.com/</a>
                    </>
                  }
                />,
                <TextDefinition
                  key="Facebook"
                  definition={
                    <>
                      Facebook: <a href="https://www.facebook.com/about/ads">https://www.facebook.com/about/ads</a>
                    </>
                  }
                />,
              ]}
            />,
            <TextDefinitionParagraph
              key="Ad industry tools"
              phrase="Ad industry tools."
              definition="Opting out of interest-based ads from companies participating in the following industry opt-out programs:"
              bullets={[
                <TextDefinition
                  key="Network Advertising Initiative"
                  definition={
                    <>
                      Network Advertising Initiative:{' '}
                      <a href="http://www.networkadvertising.org/managing/opt_out.asp">
                        http://www.networkadvertising.org/managing/opt_out.asp
                      </a>
                    </>
                  }
                />,
                <TextDefinition
                  key="Digital Advertising Alliance"
                  definition={
                    <>
                      Digital Advertising Alliance:{' '}
                      <a href="https://optout.aboutads.info">https://optout.aboutads.info</a>.
                    </>
                  }
                />,
                <TextDefinition
                  key="AppChoices"
                  definition={
                    <>
                      AppChoices mobile app, available at{' '}
                      <a href="https://www.youradchoices.com/appchoices">https://www.youradchoices.com/appchoices</a>,
                      which will allow you to opt-out of interest-based ads in mobile apps served by participating
                      members of the Digital Advertising Alliance.
                    </>
                  }
                />,
              ]}
              noMargin
            />,

            <TextDefinition
              key="Mobile settings"
              phrase="Mobile settings."
              definition="Using your mobile device settings to limit use of the advertising ID associated with your mobile device for interest-based advertising purposes."
            />,
          ]}
          noMargin
        />

        <Body4>You will need to apply these opt-out settings on each device from which you wish to opt-out.</Body4>

        <Body4>
          We cannot offer any assurances as to whether the companies we work with participate in the opt-out programs
          described above.
        </Body4>

        <TextDefinition
          phrase="Do Not Track."
          definition={
            <>
              Some Internet browsers may be configured to send &quot;Do Not Track&quot; signals to the online services
              that you visit. We currently do not respond to &quot;Do Not Track&quot; or similar signals. To find out
              more about &quot;Do Not Track,&quot; please visit{' '}
              <a href="http://www.allaboutdnt.com" target="_blank" rel="noreferrer">
                http://www.allaboutdnt.com
              </a>
              .
            </>
          }
        />

        <TextDefinition
          phrase="Declining to provide information."
          definition="We need to collect personal information to provide certain services. If you do not provide the information we identify as required or mandatory, we may not be able to provide those services."
        />

        <TextDefinition
          phrase="Linked third-party platforms."
          definition="If you choose to connect to the Service through your social media account or other third-party platform, you may be able to use your settings in your account with that platform to limit the information we receive from it. If you revoke our ability to access information from a third-party platform, that choice will not apply to information that we have already received from that third party."
        />

        <TextDefinition
          phrase="Delete your content or close your account."
          definition={
            <>
              You can choose to delete certain content through your account. If you wish to request to close your
              account, on the website please select your profile picture or initials in the top right corner of any
              page, select Settings, then navigate to the Account tab and select Close Account, or in the app please
              select your profile picture or initials in the top right corner of any screen, select Edit Account, then
              Close Account, or <a href="#contact">contact us</a>. If you have a brokerage account, please note that you
              must sell out of all equity positions, cancel any pending transactions, and withdraw all available cash
              prior to closing the account.
            </>
          }
        />
      </section>
      <section>
        <Body3>
          <span id="other-sites"></span>
          <Bold>Other sites and services</Bold>
        </Body3>

        <Body4>
          The Service may contain links to websites, mobile applications, and other online services operated by third
          parties. In addition, our content may be integrated into web pages or other online services that are not
          associated with us. These links and integrations are not an endorsement of, or representation that we are
          affiliated with, any third party. We do not control websites, mobile applications or online services operated
          by third parties, and we are not responsible for their actions. We encourage you to read the privacy policies
          of the other websites, mobile applications and online services you use.
        </Body4>
      </section>
      <section>
        <Body3>
          <span id="security"></span>
          <Bold>Security</Bold>
        </Body3>

        <Body4>
          We employ technical, organizational and physical safeguards designed to protect the personal information we
          collect. However, security risk is inherent in all internet and information technologies and we cannot
          guarantee the security of your personal information. If you have reason to believe that your interaction with
          us is no longer secure (for example, if you feel that the security of your account with us has been
          compromised), please <a href="#contact">contact us</a> immediately.
        </Body4>
      </section>
      <section>
        <Body3>
          <span id="international"></span>
          <Bold>International data transfer</Bold>
        </Body3>

        <Body4>
          We are headquartered in the United States and may use service providers that operate in other countries. Your
          personal information may be transferred to the United States or other locations where privacy laws may not be
          as protective as those in your state, province, or country.
        </Body4>
      </section>
      <section>
        <Body3>
          <span id="children"></span>
          <Bold>Children</Bold>
        </Body3>

        <Body4>
          The Service is not intended for use by anyone under 18 years of age. If you are a parent or guardian of a
          child from whom you believe we have collected personal information in a manner prohibited by law, please
          contact us at legal@tornado.com. If we learn that we have collected personal information through the Service
          from a child without the consent of the child’s parent or guardian as required by law, we will comply with
          applicable legal requirements to delete the information, to the extent permitted by applicable laws and
          regulations.
        </Body4>
      </section>
      <section>
        <Body3>
          <span id="changes"></span>
          <Bold>Changes to this Privacy Policy</Bold>
        </Body3>

        <Body4>
          We reserve the right to modify this Privacy Policy at any time. If we make material changes to this Privacy
          Policy, we will notify you by updating the date of this Privacy Policy and posting it on the Service or other
          appropriate means. Any modifications to this Privacy Policy will be effective upon our posting the modified
          version (or as otherwise indicated at the time of posting). In all cases, your use of the Service after the
          effective date of any modified Privacy Policy indicates your acceptance of the modified Privacy Policy.
        </Body4>
      </section>
      <section>
        <Body3>
          <span id="contact"></span>
          <Bold>How to contact us</Bold>
        </Body3>

        <ul>
          <li>
            <Body4>
              <Bold>Email:</Bold> legal@tornado.com
            </Body4>
          </li>
        </ul>
      </section>
    </div>
  );
};
